module.exports = __webpack_public_path__ + "img/voc.328ac59d.svg";